import { Directive, ElementRef, Input, TemplateRef } from '@angular/core';

@Directive({selector: '[queryButtonGroup]'})
export class QueryButtonGroupDirective {
  constructor(public template: TemplateRef<any>) {}
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/plugins/queryBuilder/components/query-builder/query-button-group.directive.ts